module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-create-entity-button"
  }, [_c('ModalReveal', {
    key: _vm.componentId,
    ref: _vm.componentId
  }, [(_vm.reservation !== null) ? _c('button', {
    staticClass: "button",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_vm._v("Charge session")]) : _c('a', {
    staticClass: "fa-stack fa-lg",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_c('i', {
    staticClass: "fa fa-circle fa-stack-2x"
  }), _c('i', {
    staticClass: "fa fa-plus fa-stack-1x fa-inverse"
  })]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Port"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.port_id),
      expression: "port_id"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.port_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.port_id = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Reservation ID"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation_id),
      expression: "reservation_id"
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.reservation
    },
    domProps: {
      "value": (_vm.reservation_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.reservation_id = $event.target.value
      }
    }
  })])])]), _c('ActionButton', {
    attrs: {
      "slot": "footer",
      "action": _vm.save
    },
    slot: "footer"
  }, [_vm._v("Save")]), _c('button', {
    staticClass: "button alert float-right",
    attrs: {
      "slot": "footer"
    },
    on: {
      "click": function($event) {
        return _vm.$refs[_vm.componentId].close()
      }
    },
    slot: "footer"
  }, [_vm._v("Cancel")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-050d8255!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/ChargingSessionReveal.vue
// module id = 2174
// module chunks = 1